import {
    RequestConfigFunction,
} from '../types/request.types'

type SCTPCalculation = {
    temperatureSimulation: RequestConfigFunction<Record<string, any>>
}

const sctpCalculation: SCTPCalculation = {
    temperatureSimulation: (params) => {
        return {
            url: 'temperature-simulation/v3',
            method: 'POST',
            data: params,
        }
    },
}

export default sctpCalculation
